import useRouterQueryKeyValue from '@cineamo/ui/src/hooks/useRouterQueryKeyValue';

type StripeUrlQueryParamsReturn = {
    paymentIntent?: string;
    paymentIntentClientSecret?: string;
    redirectStatus?: string;
};

export default function useStripeUrlQueryParams(): StripeUrlQueryParamsReturn {
    const { queryValue: paymentIntent } = useRouterQueryKeyValue('payment_intent');
    const { queryValue: paymentIntentClientSecret } = useRouterQueryKeyValue('payment_intent_client_secret');
    const { queryValue: redirectStatus } = useRouterQueryKeyValue('redirect_status');
    return {
        paymentIntent: paymentIntent ?? undefined,
        paymentIntentClientSecret: paymentIntentClientSecret ?? undefined,
        redirectStatus: redirectStatus ?? undefined
    };
}
